<template>
  <div>
  <Nav/>
  <div>
    <div>
    <div class="flex justify-between pl-3 pr-3 mt-2 border-b-2 pb-3">

        <div class="border-2 rounded-md px-2 py-1">
            Free Pickup
        </div>
        <div class="border-2 rounded-md px-2 py-1">
            All Discounts
        </div>
        <div class="border-2 rounded-md px-2 py-1">
            Under $25
        </div>
        <div class="border-2 rounded-md px-2 py-1">
            Filters
        </div>
    </div>
    <div class="mt-2">
        <p class="text-xs pl-3 font-bold text-gray-400">Price and other details may vary based on the product size and color</p>
    </div>
    <div class="flex ml-4 mr-4 mt-6" v-for="dress in redDress" :key="dress">
        <div>
            <div v-for="value in dress.value" :key="value">
            <a href="">
                <img v-if="value.attribute.name==='photo'" :src="`https://ecommerce-api.kalkidan.net/${value.value}`" alt="no image">

            </a>

        </div>
        <a href="">
        <div class="ml-5" >

            <div class="text-sm font-semibold w-60 mt-4" v-for="value in dress.value" :key="value">
                <div class="">
<div v-if="value.attribute.name==='Size'" class="text-xl font-serif ">
 Size : {{ value.value }}
</div>
<div v-if="value.attribute.name==='Color'" class="text-xl font-serif ">
  Color : {{ value.value }}
</div>
                </div>
                <div class="">
<div v-if="value.attribute.name==='Price'" class="text-xl font-serif ">
 price : {{ value.value }}
</div>
<div v-if="value.attribute.name==='Sex'" class="text-xl font-serif ">
    price : {{ value.value }}
</div>
                </div>
                <div v-if="value.attribute.name === 'Description'" class="w-80">
                    {{ value.value }}
                </div>

            </div>

            <div class="mt-1 text-sm font-semibold">
                #1 Top Rated <br>
                <span class="text-gray-400 font-semibold">100k+ bought in past month</span>
            </div>
            <div class="mt-1 font-semibold text-sm text-gray-400">
                No featured offers available
            </div>
            <div class="text-sm mt-2 w-40 px-2 -ml-2 ">
                <button class="border-2 px-3 rounded-2xl py-1">see more options</button>
            </div>
        </div>
    </a>
        </div>

    </div>

    <div class="mt-5">
      <div class="bg-gray-600 text-white text-center py-2">
<div><i class="fa-solid fa-caret-up"></i></div>
<div class="text-sm">TOP OF PAGE</div>
      </div>
      <div class="bg-gray-800 flex pt-3 text-white pl-5 pb-6">
<div>
  <div><a href="">Amazon.com</a></div>
  <div class="mt-5"><a href="">Your Lists</a></div>
  <div class="mt-5"><a href="">Registory & Gift List</a></div>
  <div class="mt-5"><a href="">Your Account</a></div>
  <div class="mt-5"><a href="">Sell Products on Amazon</a></div>
  <div class="mt-5"><a href="">Recalls and Product Safety <br> Alerts</a></div>
  <div class="mt-5"><a href="">Customer Service</a></div>

</div>
<div class="ml-5">
  <div><a href="">Your Orders</a></div>
  <div class="mt-5"><a href="">Gift Cards</a></div>
  <div class="mt-5"><a href="">Find a Gift</a></div>
  <div class="mt-5"><a href="">Browsing History</a></div>
  <div class="mt-5"><a href="">Your Returns</a></div>
</div>
      </div>
      <div class="bg-gray-900 text-white pt-10 pb-10">
<div class="flex ml-8">
<div class="text-sm"><i class="fa-solid fa-globe"></i> English</div>
<div class="text-sm ml-7">$ USD - US. Dollar</div>
<div class="text-sm ml-7"><img src="/united.jpg" alt="" class="w-6 h-4 inline-block"> United States</div>
</div>
<div class="mt-10">
<div class="text-center">
  Already a customer? <a href="">Sign in</a>
</div>
<div class="mt-5 flex text-xs ml-1 mr-1">
<div><a href="" class="w-80">Conditions of Use</a></div>
<div><a href="" class="ml-3">Privacy Notice</a></div>
<div><a href="" class="ml-3">Consumer Health Data Privacy Disclosure</a></div>
</div>
<div class="text-center text-xs">Your Ads Privacy Choices <input type="checkbox" class="mt-2 ml-2"></div>
<div class="text-center text-xs mt-3">&copy;1996-2024, Amazon.com, Inc. or its affiliates</div>
</div>
      </div>
     </div>
  </div>
</div>

  </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import axios from 'axios';
import { useRouter } from 'vue-router';
import { useEcommerceStore } from '@/stores/Ecommerce';
export default {
components:{
    Nav
},
data(){
return{
    // EcommerceStore:''
    redDress:[],
    redDressImages:''
}
},
mounted(){
   const EcommerceStore = useEcommerceStore()
   const router = useRouter();
   EcommerceStore.verifyLogin(router)

//     const token = localStorage.getItem('token');

// if (token) {
//   axios.defaults.withCredentials = true;
//   axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
// } else {
//   this.$router.push({ name: 'Signin' });

// }
this.fetchRedDress()
},
methods:{
    async fetchRedDress(){
        const response = await axios.get('https://ecommerce-api.kalkidan.net/api/fetchRedDress')
this.redDress = response.data.item
console.log('dress',this.redDress )
    }
}
}
</script>

<style>

</style>
